import { render, staticRenderFns } from "./profile-create.vue?vue&type=template&id=4fdcecca&"
import script from "./profile-create.vue?vue&type=script&lang=js&"
export * from "./profile-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports